export enum BillingStatusEnum {
  TRIAL = "trial",
  ACTIVE = "active",
  PAST_DUE = "past_due",
  CANCELLED = "cancelled",
}

export enum PlanTierEnum {
  STARTER = "starter",
  GROWTH = "growth",
  SCALE = "scale",
}
